
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/inspiration/gallery/[show]",
      function () {
        return require("private-next-pages/inspiration/gallery/[show].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/inspiration/gallery/[show]"])
      });
    }
  